import Viewer from 'viewerjs';

const imageViewerInit = () => {
    const imageViewers = document.querySelectorAll('.s-image-viewer');
    imageViewers.forEach(imageViewer => {
        const imageContainerImage = imageViewer.querySelector('.image-container img');
        const fullscreenButton = imageViewer.querySelector('button.image-control');
        const viewer = new Viewer(imageContainerImage, {
            navbar: 0,
            title: 0,
            movable: false,
            rotatable: false,
            tooltip: false,
            zoomRatio: 0.1,
            minZoomRatio: 0.5,
            maxZoomRatio: 1.5,
            toolbar: {
                zoomIn: {
                    show: 1,
                    size: 'large'
                },
                zoomOut: {
                    show: 1,
                    size: 'large'
                },
                reset: {
                    show: 1,
                    size: 'large'
                },
                prev: 0,
                play: 0,
                next: 0
            }
        });

        fullscreenButton.addEventListener('click', () => viewer.show());
    });
};

document.addEventListener('DOMContentLoaded', imageViewerInit);
